module.exports = __webpack_public_path__ + "static/proj3hero-2798e91e6524bcc1f1be586a25142628.png";